export enum SalesPaymentModesDropDown {
    CASH = "Cash",
    BANK = "Bank",
    CREDIT = "Credit",
}
export type SalesPaymentModeTypes = SalesPaymentModesDropDown.CASH | SalesPaymentModesDropDown.BANK | SalesPaymentModesDropDown.CREDIT

export enum SalesReturnActionList {
    ADD_SALESRETURN = 'ADD_SALESRETURN',
    FETCH_SALESRETURN = 'FETCH_SALESRETURN',
    UPDATE_SALESRETURN = 'UPDATE_SALESRETURN',
    DELETE_SALESRETURN = 'DELETE_SALESRETURN',
}

export interface SalesReturnItems {
    salesReturnId?: number
    entryNumber: number
    productId?: number
    productGroupCode?: string
    productCode: string
    batchNumber: number
    expiryDate: string
    quantity: string
    freeQuantity: string
    totalQuantity: string
    priceWogst: number
    priceGst: number
    wRate: number
    mrp: number
    gstValue: number
    sDiscount: number
    pDiscountpercent: number
    pDiscountamount: number
    cDiscountpercent: number
    cDiscountamount: number
    taxableAmount: number
    igstAmount: number
    cgstAmount: number
    sgstAmount: number
    totalAmount: number
    unitCost: number
    profitPercent: number
    profitAmount: number
}

export interface SalesReturnType {
    id?: number
    salesId?: number
    salesInvoiceNo?: string
    financeYear: string
    branchId: number
    invoiceType: string
    invoiceTitle: string
    invoiceDate?: string
    invoiceHour?: string
    invoiceDay?: string
    invoiceWeekNumber?: number
    invoiceWeekDay?: number
    invoiceMonth?: number
    invoiceYear?: number
    invoiceNumber: string
    packNo: string
    salesReturnEntryNumber: number
    systemNo: string
    placeOfSupply?: string
    repId?: number
    customerId: number
    customerName: string
    salesReturnItems: SalesReturnItems[]
    pointsEarned?: string
    bankName: string
    bankNumber: number
    paymentMode: SalesPaymentModeTypes
    billAmount?: string
    disPercent?: string
    disAmount?: string
    add?: string
    less?: string
    grandTotal?: string
    amtInWords?: string
    particulars?: string
    amtPaid?: string
    deliveryMode?: string
    deliveryDetails?: string
    remarks?: string,
    tenderAmt?: string
    tenderReturn?: string
    netTaxable?: string
    netIgst?: string
    netSgst?: string
    netCgst?: string
    netProfit?: string
    netProfitPercent?: string
    AValue?: string
    ATaxable?: string
    BValue?: string
    BTaxable?: string
    CValue?: string
    CTaxable?: string
    DValue?: string
    DTaxable?: string
    EValue?: string
    ETaxable?: string
    FValue?: string
    FTaxable?: string
    GValue?: string
    GTaxable?: string
    split?: string
    transactions: ({
        paymentMode: string;
        particulars: string;
        amtPaid: number;
    })[]
}
